<div class="dgoods-view-container">
    <ng-content></ng-content>
</div>
